import { UserNameIdDto } from '../../../../api/api-types';

export const getEmployeeOptions = (employees: UserNameIdDto[]) => {
  return employees.map(({ id, name }) => ({
    label: name || '',
    value: id || null,
  }));
};
